import PropTypes from 'prop-types'
import React from 'react'
import {
  WayToBookIntro,
  WayToBookMain,
  WayToBookNav,
  WayToBookNavList,
} from './index.style'

// Components
import { getSrc } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import RichText from '../RichText'
import ScrollSection from '../ScrollSection'
import Spacer from '../Spacer'
import { Heading3 } from '../TextStyles'
import WayToBookCard from '../WayToBookCard'
import AnimateSplitText from '../animation/AnimateSplitText'

// Styles

const WayToBook = ({ forwardRef, heading, intro, image, cards, id }) => {
  const sliderSettings = {
    infinite: false,
    arrows: false,
    dots: true,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 10000,
        settings: 'unslick',
      },
      {
        breakpoint: 1239,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 875,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const imageSource = getSrc(image.gatsbyImageData)

  return (
    <ScrollSection>
      <WayToBookMain ref={forwardRef} bg={imageSource} id={`ways-to-book`}>
        <Spacer size={[55, 150]} />
        <Container>
          <Grid>
            <GridItem deskL={10} deskLStart={2}>
              <WayToBookNav>
                <WayToBookNavList>
                  <WayToBookIntro>
                    <AnimateSplitText id={`${id}-title`}>
                      <Heading3>{heading}</Heading3>
                    </AnimateSplitText>
                    <Spacer size={[18, 16]} />
                    <RichText content={intro} id={`${id}-text`} />
                  </WayToBookIntro>
                  <Spacer size={[20, 50]} />
                  <Slider {...sliderSettings}>
                    {React.Children.toArray(
                      cards.map((card, cardIndex) => {
                        return (
                          <WayToBookCard
                            headingItalic={card.headingItalic}
                            headingNormal={card.headingNormal}
                            text={card.text}
                            cta={card.link}
                            image={card.backgroundImage}
                            delay={cardIndex * 0.1}
                            id={`wayToBookCard-${cardIndex}`}
                            key={`wayToBookCard-${cardIndex}`}
                          />
                        )
                      })
                    )}
                  </Slider>
                </WayToBookNavList>
              </WayToBookNav>
            </GridItem>
          </Grid>
        </Container>
        <Spacer size={[45, 150]} />
      </WayToBookMain>
    </ScrollSection>
  )
}

WayToBook.propTypes = {
  intro: PropTypes.object,
  cards: PropTypes.array,
  image: PropTypes.object.isRequired,
}

export default WayToBook
